module.exports = __webpack_public_path__ + "static/img/200040.0068c653.png";